import { keycloak, GOOGLE_KEY } from "../../constants";

const basePath = `${process.env.REACT_APP_BACKEND_HOST}/api/`;
const basePathV2 = `${process.env.REACT_APP_BACKEND_HOST}/apiV2/`;
const logInPath = `${process.env.REACT_APP_BLACKBOLT}/`;
// const mockableBasePath = "https://demo7974334.mockable.io/apiV2/";
// const mockableBasePath = "http://localhost:8082/apiV2/";

const apis = {
  basePathV1: `${basePath}`,
  basePathV2: `${basePathV2}`,
  masterTemplates: `${basePathV2}masterTemplates`,
  getType: `${basePath}getType`,
  mobileHeader: `${basePath}header?type=website_homepage&platform=mobile`,
  desktopHeader: `${basePathV2}header`,
  filter: `${basePath}search/filters`,
  forgotPassword: `${logInPath}login/users/end-user/forgot-password`,
  footerLink: `${basePath}footerlinks?url=${window.location.hostname}`,
  storesList: `${basePath}searchFulfillmentCenters?isodin=2`,
  registerUser: `${basePath}blackbolt/register`,
  account: `${basePath}account`,
  mybag: `${basePath}mybag/v2`,
  mergeCart: `${basePath}myBag/v3`,
  mybagGuest: `${basePath}myBag/overview/v3`,
  myBagDetails: `${basePath}myBag/v3`,
  addToBag: `${basePath}myBag/v3`,
  removeFromBag: `${basePath}myBag/remove/v3`,
  socialLogin: `${logInPath}login/users/end-user/token`,
  login: `${logInPath}login/users/end-user/token`,
  brandList: `${basePath}search/filters`,
  brandListNew: `${basePath}storelocator/brands/v2`,
  allProductData: `${basePathV2}listing/products`,
  omniFiltersData: `${basePathV2}listing/omni`,
  listingDetails: `${basePath}listing/details`,
  resetPassword: `${logInPath}login/auth/admin/realms/${
    keycloak.realm
  }/user/resetpassword?`,
  token: `${logInPath}login/auth/api/v2/realms/${
    keycloak.realm
  }/protocol/openid-connect/token`,
  details: `${basePath}product/details`,
  getWishList: `${basePath}fav/v2`,
  setWishList: `${basePath}fav/v2/products`,
  getBrandWishList: `${basePath}favourite`,
  setBrandWishList: `${basePath}favourite/brand/`,
  deleteWishList: `${basePath}fav/delete`,
  pincode: `${basePath}product/shippingAndStoreDetails`,
  sizeCharts: `${basePath}sizeCharts`,
  recentlyViewedStyles: `${basePath}product/recentlyViewedStyles`,
  multipleStyles: `${basePath}product/multipleStyles`,
  similarStyles: `${basePath}product/similarStyles`,
  urlShortener: `https://www.googleapis.com/urlshortener/v1/url?key=${GOOGLE_KEY}`,
};

export default { ...apis };



// WEBPACK FOOTER //
// ./src/api/endPoints/apiEndpoints.js